
// src/connects/search-timeline-page.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'
import find from 'lodash/find'
import map from 'lodash/map'
import isEqual from 'lodash/isEqual'
import moment from 'moment'
import context from '../helpers/context'
import isNaN from 'lodash/isNaN'

export const mapStateToProps = (state, ownProps)=> {
  const preservedQuery = ownProps.params.query_id && state.preservedQueries.items && find(state.preservedQueries.items, (query)=> query.query_id == ownProps.params.query_id) || undefined
  const group_id = ownProps.params.group_id || preservedQuery && preservedQuery.group_id || undefined

  return {
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    isCreating: state.preservedQueries.isCreating,
    created_query_id: state.preservedQueries.created_query_id,
    hasMore: state.subDiaries.hasMore,
    diaries: state.subDiaries.items,
    group: group_id && find(state.groups.items, (item)=> item.group_id == group_id) || undefined,
    user: state.user.current,
    preservedQuery: preservedQuery && Object.assign({}, JSON.parse(preservedQuery.query_text), { query_id: preservedQuery.query_id, name: preservedQuery.name, group_id: preservedQuery.group_id, users: preservedQuery.users }),
    rightSidePage: state.rightSidePage.name,
    likeConfig: state.likes.likeConfig,
    currentDivisionId: state.divisions.currentId,
  }
}

function mapFetchGroupId(props) {
  return props.preservedQuery ? props.preservedQuery.group_id : props.params.group_id
}

function mapFetchQuery(props) {
  var query = {}
  if (props.preservedQuery) {
    if (props.preservedQuery.category)
      query.category = props.preservedQuery.category
    if (props.preservedQuery.user_ids)
      query.user_ids = props.preservedQuery.user_ids
    if (props.preservedQuery.reported_at)
      query.start_date = props.preservedQuery.reported_at
    if (props.preservedQuery.files_attached)
      query.files_attached = true
    if (props.preservedQuery.liked_by)
      query.liked_by = props.preservedQuery.liked_by
    if (props.preservedQuery.queryText)
      query.query = props.preservedQuery.queryText
  }
  else {
    if (props.params.category && props.params.category != 'all')
      query.category = props.params.category
    if (props.params.users)
      query.user_ids = map(props.params.users, (user)=> user.user_id).join(',')
    if (props.params.reported_at)
      query.start_date = moment(props.params.reported_at).format('YYYY-MM-DD')
    if (props.params.files_attached)
      query.files_attached = true
    if (props.params.liked_by)
      query.liked_by = props.params.liked_by
    if (props.params.query && props.params.query.length > 0)
      query.query = props.params.query
  }
  if (!isNaN(props.currentDivisionId))
    query.division_id = props.currentDivisionId
  return query
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    fetchDiaries: (props)=> {
      if (props.isFetching || props.isFetchFailed || !props.hasMore) return
      const query = mapFetchQuery(props)
      const group_id = mapFetchGroupId(props)
      if (group_id)
        dispatch(actions.searchDiaries(group_id, props.diaries && props.diaries.length || 0, query))
      else
        dispatch(actions.searchHomeDiaries(props.diaries && props.diaries.length || 0, query))
    },

    willMount: (props)=> {
      const query = mapFetchQuery(props)
      const group_id = mapFetchGroupId(props)
      if (group_id)
        dispatch(actions.searchDiaries(group_id, 0, query))
      else
        dispatch(actions.searchHomeDiaries(0, query))
    },

    deletePreservedQuery: (query)=> {
      dispatch(actions.deletePreservedQuery(query.query_id))
      dispatch(emitAlertMessage({ message: 'label:検索条件を削除しました', name: query.name }, 'success'))
      dispatch(actions.closeRightSidePage())
    },

    createPreservedQuery: (name)=> {
      if (!ownProps.params.query_id) {
        dispatch(actions.createPreservedQuery(
          name,
          JSON.stringify({
            category: ownProps.params.category == 'all' ? undefined: ownProps.params.category,
            files_attached: ownProps.params.files_attached,
            liked_by: ownProps.params.liked_by,
            user_ids: ownProps.params.users && ownProps.params.users.map((user)=> user.user_id).join(','),
            reported_at: ownProps.params.reported_at && moment(ownProps.params.reported_at).format('YYYY-MM-DD') || undefined,
            queryText: ownProps.params.query,
          }),
          ownProps.params.group_id
        ))
      }
    },

    readDiary: (props, diary)=> {
      const read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && find(diary.readers, (reader)=> reader.user.user_id == props.user.user_id)
      !read && dispatch(actions.markDiaryRead(diary.diary_id))
    },

    willUpdate: (props, nextProps)=> {
      if (!isEqual(props.params, nextProps.params)) {
        const query = mapFetchQuery(nextProps)
        const group_id = mapFetchGroupId(nextProps)
        if (group_id)
          dispatch(actions.searchDiaries(group_id, 0, query))
        else
          dispatch(actions.searchHomeDiaries(0, query))
      }

      if (props.isCreating && !nextProps.isCreating && nextProps.created_query_id) {
        dispatch(emitAlertMessage('label:検索条件を保存しました', 'inputSuccess'))
        dispatch(actions.openRightSidePage('search_timeline', ownProps.params && ownProps.params.isHome ?
          { query_id: nextProps.created_query_id, isHome: ownProps.params.isHome }:
          { query_id: nextProps.created_query_id }))
      }
    },

    willUnmount: ()=> dispatch(actions.clearSubDiaries()),

    // アプリでsearch-drawerを開くために必要
    appEditSearchDrawer: (group) => {
      const isHome = ownProps.params.isHome
      dispatch(actions.openRightSidePage('search_drawer', isHome ? { group_id: 'home' } : { group: group }))
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    keyboardHeight: undefined,
  }}),
  lifecycle,
  translate(),
  trackPage('search_timeline'),
  context({ editSearchDrawer: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/search-timeline-page.js